import classNames from "classnames";
import styles from "./style.module.scss";
import SkeletonLoader from "shared/components/common/skeleton";

interface NotificationsListSkeletonProps {
  unreadCount?: number;
  readCount?: number;
  showDateHeaders?: boolean;
}

const NotificationsListSkeleton = ({
  unreadCount = 2,
  readCount = 3,
  showDateHeaders = true,
}: NotificationsListSkeletonProps) => {
  return (
    <div className={classNames(styles.pageWrapper, "flex flex-col")}>
      <div className="grid gap-3">
        {unreadCount > 0 && (
          <>
            {showDateHeaders && (
              <div className="mb-3">
                <div className={styles.dateHeaderSkeleton}>
                  <SkeletonLoader className={styles.dateIconSkeleton} />
                  <SkeletonLoader className={styles.dateTextSkeleton} />
                  <SkeletonLoader className={styles.unreadCountSkeleton} />
                </div>
              </div>
            )}

            <div className={classNames(styles.unreadNotifications)}>
              {Array.from({ length: unreadCount }).map((_, index) => (
                <div
                  key={`unread-skeleton-${index}`}
                  className={styles.notificationCardSkeleton}
                >
                  <SkeletonLoader className={styles.iconSkeleton} />
                  <div className={styles.contentSkeleton}>
                    <SkeletonLoader className={styles.cardTitleSkeleton} />
                    <SkeletonLoader
                      className={styles.cardDescriptionSkeleton}
                    />
                    <div className={styles.metaSkeleton}>
                      <SkeletonLoader className={styles.authorSkeleton} />
                      <SkeletonLoader className={styles.timeSkeleton} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {readCount > 0 && (
          <div className={classNames(styles.readEnclosure, "grid")}>
            {showDateHeaders && (
              <div className={styles.dateHeaderSkeleton}>
                <SkeletonLoader className={styles.dateIconSkeleton} />
                <SkeletonLoader className={styles.dateTextSkeleton} />
              </div>
            )}

            <div className={classNames(styles.notificationsEnclosure)}>
              {Array.from({ length: readCount }).map((_, index) => (
                <div
                  key={`read-skeleton-${index}`}
                  className={styles.notificationCardSkeleton}
                >
                  <SkeletonLoader className={styles.iconSkeleton} />
                  <div className={styles.contentSkeleton}>
                    <SkeletonLoader className={styles.cardTitleSkeleton} />
                    <SkeletonLoader
                      className={styles.cardDescriptionSkeleton}
                    />
                    <div className={styles.metaSkeleton}>
                      <SkeletonLoader className={styles.authorSkeleton} />
                      <SkeletonLoader className={styles.timeSkeleton} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationsListSkeleton;
